import React from 'react';
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
import GuiasTransportista from './GuiasTransportista';
import { Button, Dialog, DialogActions, DialogContent, Icon, IconButton, Slide, Snackbar } from '@material-ui/core';
import GuiaPago from './GuiaPago';
import './PagoEntrega.css';
import BusquedaDirecta from './BusquedaDirecta';

class PagoEntrega extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'contra-recibo/one', saveUrl: 'contra-recibo/save', backUrl: 'jfhdfs' },
      new Form([
        // Form.Field('select', 'id_transportista', 'Transportista', 0, [Validators.required], 6),
        Form.Field('number', 'total', 'Total', 0, [], 12, [], [], [], true, true),
      ], ['Guardar'], 'Pago a transportista'), this.formData
    )

    // this.LoadPreds(this.props.factura.id, false);
    this.loadPreds();
  }

  loadPreds = async () => {
    if (!this.props.idPago) return;
    try {
      let res = await Http.get(`pago-transportista/one/${this.props.idPago}`);
      if (!res.error) {
        this.setState({ FormData: Form.Patch(this.state.FormData, res.data, true), guias: res.data.guias });
      }
    } catch (error) {
      console.log(error);
    }
  }

  formData = async (form) => {
    let newForm = form;
    // let Res = await Http.get('pago-transportista/form');
    // console.log(Res);
    // if (!Res.error) {
    //   newForm = Form.FieldOptions(form, 'id_transportista', [...Res.data.transportistas], 'id', 'transportista_nombre');
    // }

    // newForm = Form.ValueChange(newForm, {
    //   id_transportista: this.onTransportistaChange,
    // });

    return newForm;
  }

  onTransportistaChange = (field) => {
    console.log(field)
    this.setState({ idTransportista: field.Value });
  }

  onSubmit = async (button, vals) => {
    // console.log(vals);
    this.savePago(vals);
  }

  savePago = async (pagoTransportista) => {
    this.setState({ loading: true });
    try {
      // console.log(vals);
      pagoTransportista.id = this.props.idPago;
      let res = await Http.post(`pago-transportista/save`, {
        pago_transportista: pagoTransportista,
        guias: this.state.guias || []
      });
      console.log(res);
      if (res.error) {
        this.setState({ SB: { open: true, msg: 'Error al guardar el pago' } });
      }
      else {
        this.setState({ SB: { open: true, msg: 'Guardado' }, guias: res.data.guias });
        this.props.onSave();
      }
    } catch (error) {
      console.log(error)
    }
    this.setState({ loading: false });
  }

  onAddGuia = (idGuia, folio = false) => {
    this.setState({ modalGuia: { visible: true, idGuia, byFolio: folio } });
  }

  onGuiaClose = () => {
    this.setState({ modalGuia: { visible: false, idGuia: null } });
  }

  onConfirmGuia = (res) => {
    const { guias = [], modalGuia } = this.state;
    let found = guias.find(guia => guia.id_guia === modalGuia.idGuia && !guia.deleted);
    if (found) {
      this.setState({ SB: { open: true, msg: 'La guía ya fue agregada' }, modalGuia: { visible: false } });
      return;
    }
    console.log(res);
    guias.push({
      // id_guia: modalGuia.idGuia,
      id_guia: res.id,
      total: res.valor,
      g_folio: res.folio
    });
    this.setState({ guias, modalGuia: { visible: false } }, () => this.sumarPagos());
  }

  onDeleteGuia = (guia) => {
    let { guias = [] } = this.state;
    guias = guias.map(g => {
      if (g.id_guia === guia.id_guia)
        g.deleted = true;
      return g;
    });
    this.setState({ guias });
  }

  sumarPagos = () => {
    let { guias = [] } = this.state;
    let total = 0;
    guias.forEach(guia => {
      total += parseFloat(guia.total);
    });
    // this.setState({ FormData: Form.FieldMod(this.state.FormData, 'total', 'Value', total) });
    this.setState({ FormData: Form.Patch(this.state.FormData, { total }, true) });
  }

  render() {
    const { idTransportista = 0, modalGuia = { visible: false }, guias = [], SB = {} } = this.state;

    return (
      <div style={{ backgroundColor: 'white' }}>
        <this.FormRender />

        {
          guias.length > 0 && (
            <table>
              <thead>
                <tr>
                  <td>Folio</td>
                  <td>Valor</td>
                  <td>Acciones</td>
                </tr>
              </thead>
              <tbody>
                {guias.map((guia, gi) => (!guia.deleted &&
                  <tr key={guia.id_guia}>
                    <td>{guia.g_folio}</td>
                    <td>{guia.total}</td>
                    <td>
                      <IconButton onClick={() => this.onDeleteGuia(guia)} size='small'><Icon>delete</Icon></IconButton>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )
        }

        <div>
          <BusquedaDirecta onAddGuia={(id) => this.onAddGuia(id, true)} />
        </div>

        <div>
          <GuiasTransportista idTransportista={idTransportista} onAddGuia={this.onAddGuia} />
        </div>

        <Dialog
          onClose={this.onGuiaClose}
          open={modalGuia?.visible}
          // fullWidth={true}
          maxWidth={"xl"}
        >
          <DialogContent dividers>
            <GuiaPago idGuia={modalGuia.idGuia} byFolio={modalGuia.byFolio} onAdd={this.onConfirmGuia} />
          </DialogContent>
          <DialogActions>
            {/* <Button onClick={this.onConfirmGuia}>Agregar</Button> */}
            <Button onClick={this.onGuiaClose}>Cerrar</Button>
          </DialogActions>
        </Dialog>

        <Snackbar
          open={SB.open}
          onClose={() => { this.setState({ SB: { open: false } }) }}
          TransitionComponent={Slide}
          message={<span>{SB.msg}</span>}
        />
      </div>
    )
  }
}

export default withRouter(PagoEntrega)
